/**
@ngdoc directive
@name multiSelectTagSearch

@description
Dropdown search box enabling selection of multiple tags in one search

@usage
    <multi-select-tag-search
        id:                        string             // ensures the component can be differentiated on the page if there are multiple
        rowid:                     string             // fieldvalue index value
        source:                    string             // url to query for dropdown data
        placholder:                string             // displayed if no text has been entered into search box
        typeahead-length:          number             // minimum size of string before dropdown filtering takes place
        items-pre-selected:       {id: boolean}[]     // if refining a search, what tags have previously been selected
        values-selected-output:   {id: number,        // this will contain an array of selected objects
                                    name: string,
                                    text: string,
                                    selected: boolean
                                  }[]
	></multi-select-tag-search>
*/

(function () {
  "use strict";

  var multiSelectTagSearch = function ($http, $templateCache) {
    return {
      restrict: "EA",
      scope: {
        id: "@",
        rowid: "@",
        source: "@",
        placeholder: "@",
        typeaheadLength: "@",
        itemsPreSelected: "=",
        valuesSelectedOutput: "=",
      },
      replace: true,
      transclude: false,
      template: $templateCache.get("formWidget/multiSelectTagSearch.html"),
      controller: [
        "$scope",
        function ($scope) {
          $scope.dropdownList = [];
          $scope.selectedValues = [];
          $scope.searchTermValue = "";
          $scope.isLoading = false;
          $scope.showDropdown = false;

          this.$onInit = function () {
            addListeners();
            var attempts = 0;
            var timeout = setTimeout(function () {
              if (attempts >= 5) clearTimeout(timeout);
              if ($scope.itemsPreSelected) {
                $scope.selectedValues = $scope.itemsPreSelected;
              } else {
                ++attempts;
              }
            }, 500);
          };

          $scope.filter = function () {
            if ($scope.searchTermValue.length >= $scope.typeaheadLength) {
              $scope.isLoading = true;
              getData().then(function (response) {
                $scope.dropdownList = response.data;
                persistCheckedValues();
                $scope.showDropdown = true;
                $scope.isLoading = false;
              });
            }
          };
          $scope.onItemClicked = function (itemClicked) {
            if (arrayHas($scope.selectedValues, itemClicked)) {
              arrayRemove($scope.selectedValues, itemClicked);
            } else {
              $scope.selectedValues.push(itemClicked);
            }
            $scope.valuesSelectedOutput = $scope.selectedValues;
          };
          $scope.onSelectedValueRemoved = function (itemRemoved) {
            if (arrayHas($scope.selectedValues, itemRemoved)) {
              arrayRemove($scope.selectedValues, itemRemoved);
              itemRemoved.selected = false;
            }
            $scope.valuesSelectedOutput = $scope.selectedValues;
          };
          $scope.onSelectAll = function () {
            $scope.selectedValues = Array.from(
              new Set($scope.dropdownList.concat($scope.selectedValues))
            );
            $scope.selectedValues.forEach(function (item) {
              item.selected = true;
            });
            $scope.valuesSelectedOutput = $scope.selectedValues;
          };
          $scope.onClearAll = function () {
            $scope.dropdownList.forEach(function (item) {
              if (item.selected && arrayHas($scope.selectedValues, item)) {
                arrayRemove($scope.selectedValues, item);
                item.selected = false;
              }
            });
            $scope.valuesSelectedOutput = $scope.selectedValues;
          };
          $scope.onClearAllTags = function () {
            $scope.selectedValues = [];
            $scope.dropdownList.forEach(function(item) {
              item.selected = false;
            })
          }
          $scope.clearSearchTerm = function () {
            $scope.searchTermValue = "";
            $scope.showDropdown = false;
          };

          function getData() {
            return $http.get(
              $scope.source + "&q=" + encodeURIComponent($scope.searchTermValue),
              {}
            );
          }

          function persistCheckedValues() {
            $scope.selectedValues.forEach(function (selectedItem) {
              $scope.dropdownList.forEach(function (listItem) {
                if (selectedItem.id == listItem.id) {
                  listItem.selected = true;
                }
              });
            });
          }

          function arrayHas(array, checkItem) {
            var has = false;
            array.forEach(function (item) {
              if (item.id == checkItem.id) {
                has = true;
              }
            });
            return has;
          }

          function arrayRemove(array, item) {
            const index = array
              .map(function (element) {
                return element.id;
              })
              .indexOf(item.id);
            if (index == -1) return;
            array.splice(index, 1);
          }

          function addListeners() {
            $(document).mouseup(function (e) {
              var container = $("#" + $scope.id);
              if (
                !container.is(e.target) &&
                container.has(e.target).length === 0
              ) {
                $scope.showDropdown = false;
              } else if (
                $scope.searchTermValue.length >= $scope.typeaheadLength
              ) {
                $scope.showDropdown = true;
              }
            });
          }
        },
      ],
      require: "^form",
    };
  };
  multiSelectTagSearch.$inject = ["$http", "$templateCache"];
  angular.module("app").directive("multiSelectTagSearch", multiSelectTagSearch);
})();
